import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Table, TableProps } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import { useColumnLocalSort, useTableSearchParams } from 'src/libs'
import { ErrorScreen } from 'src/shared/components/errorScreen/errorScreen'
import { setHistoryLoginsRequestError } from './model'
import { useHistoryLoginsWidget } from './hooks'
import { HistoryLogin } from './types'

export const HistoryLoginsWidget = () => {
  return (
    <CCard>
      <CCardHeader>
        <strong>Activity</strong>
      </CCardHeader>
      <CCardBody>
        <div className="m-1">Login history</div>
        <HistoryLoginsList />
      </CCardBody>
    </CCard>
  )
}

const HistoryLoginsList = () => {
  return <HistoryLoginsTable />
}

const HistoryLoginsTable = () => {
  const [searchParams] = useSearchParams()
  const {
    historyLogins,
    errorHistoryLoginsRequest,
    loading,
    totalCountOfHistoryLogins,
    onChangeHistoryLoginsList,
  } = useHistoryLoginsWidget()

  const sorterFields = ['loggedInAt']
  const handleTableChange: TableProps<HistoryLogin>['onChange'] =
    useTableSearchParams({
      sorterFields,
      usePagination: true,
    })

  useEffect(() => {
    onChangeHistoryLoginsList({
      limit: Number(searchParams.get('limit')) || 10,
      page: Number(searchParams.get('page')) || 1,
      sorterField: searchParams.get('sorterField') ?? '-loggedInAt',
    })
  }, [searchParams])

  const columns: ColumnsType<HistoryLogin> = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Logged in',
      dataIndex: 'loggedInAt',
      sorter: true,
      ...useColumnLocalSort<HistoryLogin>({
        dataIndex: 'loggedInAt',
        initialValue: 'descend',
      }),
    },
    {
      title: 'Product',
      dataIndex: 'product',
    },
    {
      title: 'Client IP',
      dataIndex: 'ip',
    },
  ]

  if (![0, 404].includes(errorHistoryLoginsRequest.code)) {
    return (
      <ErrorScreen
        showRetry
        onRetry={() => {
          onChangeHistoryLoginsList({
            limit: Number(searchParams.get('limit')) || 10,
            page: Number(searchParams.get('page')) || 1,
            sorterField: searchParams.get('sorterField') ?? '-loggedInAt',
          })
          setHistoryLoginsRequestError({
            message: '',
            code: 0,
          })
        }}
      />
    )
  }
  const current = Number(searchParams.get('page')) || 1
  const pageSize = Number(searchParams.get('limit')) || 10
  return (
    <Table
      dataSource={historyLogins}
      bordered={true}
      scroll={{ x: true }}
      loading={loading}
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {},
        }
      }}
      rowKey="id"
      columns={columns}
      pagination={{
        current,
        pageSize,
        showSizeChanger: true,
        total: totalCountOfHistoryLogins,
      }}
      onChange={handleTableChange}
    />
  )
}
